export enum PaymentStatus {    
    pending,       // El usuario no completó el proceso de pago 
    approved,      // El pago fue aprobado y acreditado
    in_process,    // El pago está siendo revisado
    rejected,      // El pago fue rechazado. El usuario puede intentar nuevamente
    cancelled,     // El pago fue cancelado por superar el tiempo necesario para realizar el pago o por una de las partes    
    refunded,      // El pago fue devuelto al usuario    
    in_mediation,  // Se inició una disputa para el pago    
    charged_back,  // Se realizó un contracargo en la tarjeta de crédito
}